export const detectionEvent = "conflict-detection.ubo-detected";
